/**
 *  EDAP helpers
 */

const simulateClick = (href, target = '') => {
  if (target === '_blank') {
    window.open(href);
  } else {
    window.location.href = href;
  }

  return false;
};

const triggerEdapEvent = (edapEvent, params = {}, edapOptions = {}) => {
  if (typeof window !== 'undefined' && window !== null) {
    const {
      name,
      data: eventOptions
    } = typeof edapEvent === 'function' ? edapEvent(params) : edapEvent;

    return window.edap.push(edap => edap.trigger(name, eventOptions, edapOptions));
  }
  return false;
};

const handleEdapClick = (edapEvent, params) => (evt) => {
  evt.preventDefault();

  triggerEdapEvent(edapEvent, params, { delayProcessing: true });

  const href = evt.currentTarget.getAttribute('href');
  const target = evt.currentTarget.getAttribute('target');
  simulateClick(href, target || '');
};

export {
  handleEdapClick,
  triggerEdapEvent,
  simulateClick
};



// WEBPACK FOOTER //
// ./src/universal/utils/edap.js